import { Popover as BasePopover } from '@base-ui/react/popover';
import type {
  PopoverPopupProps,
  PopoverPositionerProps,
} from '@base-ui/react/popover';

import { cn } from '@/libs';

export const Root = BasePopover.Root;
export const Trigger = BasePopover.Trigger;
export const Title = BasePopover.Title;
export const Description = BasePopover.Description;
export const Close = BasePopover.Close;

const cardClassName =
  'relative max-w-[min(410px,calc(100vw-2rem))] rounded-lg bg-base-light p-[20px_15px] text-start shadow-popover outline-none';

/** A rotated square that pokes out of the edge facing the anchor. */
const arrowClassName =
  'size-[11px] rotate-45 rounded-sm bg-base-light data-[side=bottom]:-top-[5px] data-[side=top]:-bottom-[5px] data-[side=left]:-right-[5px] data-[side=right]:-left-[5px]';

type ContentProps = Omit<PopoverPopupProps, 'className' | 'ref'> & {
  /** Element to point at when the popover has no `Trigger`. */
  anchor?: PopoverPositionerProps['anchor'];
  side?: PopoverPositionerProps['side'];
  align?: PopoverPositionerProps['align'];
  sideOffset?: number;
  className?: string;
};

/** The light help card with its portal, positioning and arrow. */
export const Content = ({
  anchor,
  side = 'bottom',
  align = 'center',
  sideOffset = 10,
  className,
  children,
  ...props
}: ContentProps) => (
  <BasePopover.Portal>
    <BasePopover.Positioner
      className="z-popover"
      anchor={anchor}
      side={side}
      align={align}
      sideOffset={sideOffset}
    >
      <BasePopover.Popup className={cn(cardClassName, className)} {...props}>
        {children}
        <BasePopover.Arrow className={arrowClassName} />
      </BasePopover.Popup>
    </BasePopover.Positioner>
  </BasePopover.Portal>
);
